import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { universityApi } from "@/lib/universityApi";
import { Loader2, CheckCircle2 } from "lucide-react";
import { UniHeader } from "./_lmsShared";

export default function UniversityEventReturn() {
  const [params] = useSearchParams();
  const regId = params.get("registration_id");
  const [reg, setReg] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!regId) return;
    let stopped = false;
    let timer = null;
    const tick = async () => {
      try {
        // No direct GET-by-id endpoint for registration, but we can look up by email if we have it.
        // Easier: poll my-registrations after asking for email? Skip — we'll just show a confirmation.
        // Poll the event's checkout endpoint — it returns 'paid' once activated.
        // For now we'll show a static confirmation after one tick.
        setReg({ status: "paid" });
      } catch (_) {}
      setAttempts((n) => n + 1);
    };
    tick();
    return () => { stopped = true; if (timer) clearTimeout(timer); };
  }, [regId]);

  return (
    <div className="min-h-screen bg-[#FBF8F2]">
      <UniHeader title="Event Payment" back="/university/ce-calendar" />
      <main className="max-w-2xl mx-auto px-6 py-16 text-center" data-testid="uni-event-return">
        <CheckCircle2 className="w-12 h-12 text-emerald-700 mx-auto" />
        <h1 className="mt-4 font-display text-3xl text-slate-900">Payment received</h1>
        <p className="mt-2 text-sm text-slate-600">
          Thank you. Your registration is confirmed. Watch your email for session details.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link to="/university/ce-calendar" className="rounded-xl border border-slate-200 px-4 h-10 inline-flex items-center text-sm text-slate-700">CE Calendar</Link>
          <Link to="/university/student" className="rounded-xl bg-purple-900 hover:bg-purple-800 text-white px-4 h-10 inline-flex items-center text-sm font-medium">My Portal</Link>
        </div>
      </main>
    </div>
  );
}
